<script setup lang="ts">
defineProps<{ label?: string }>()
</script>

<template>
    <div class="information-base-card background-secondary primary-border border-radius">
        <div v-if="label" class="field is-floating-label">
            <span class="label">{{ label }}</span>
        </div>
        <div class="information-card-content color-text flex">
            <slot class="card" />
        </div>
    </div>
</template>

<style scoped lang="scss">
.field.is-floating-label .label::before {
    top: 0.4em;
}
.information-card-content {
    padding: 1rem;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    min-height: 5rem;

    & :deep(.input) {
        background-color: var(--color-background-secondary);
    }
    & :deep(.field.is-floating-label .label::before) {
        background-color: var(--color-background-secondary);
    }
}
.information-card-content .input {
    background-color: var(--color-background-secondary);
}
</style>
